import { connect } from 'react-redux';
import React, { Component } from 'react';

import MuiTooltip from 'material-ui/internal/Tooltip';

class Tooltip extends Component {
  render() {
    return (
      !this.props.show ? null :
      <MuiTooltip
        show={this.props.show}
        label={this.props.message}
        style={{fontSize: '16px', top: this.props.y, left: this.props.x, cursor: 'pointer'}}/>
    );
  }
}

export default connect(
  state => (
    {
      show: state.get('tooltip').get('visible'),
      message: state.get('tooltip').get('message'),
      x: state.get('tooltip').get('x'),
      y: state.get('tooltip').get('y')
    }
  ),
  dispatch => (
    {

    }
  )
)(Tooltip);
